export default __webpack_public_path__ + "static/media/JobThree3.2844bb96.JPG";